var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconBusinessSettings = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 1 27 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2857 17.2308V24H8.71429V17.2308H17.2857ZM5.28571 17.2308C3.65714 17.2308 2.11429 16.5538 1 15.4538V21.4615C1 22.9 2.11429 24 3.57143 24H7V17.2308H5.28571ZM25 6.23077V11.3077C25 13.6769 23.1143 15.5385 20.7143 15.5385H5.28571C2.88571 15.5385 1 13.6769 1 11.3077V6.23077C1 5.72308 1.34286 5.38462 1.85714 5.38462H7.85714V2.84615C7.85714 2.33846 8.2 2 8.71429 2H17.2857C17.8 2 18.1429 2.33846 18.1429 2.84615V5.38462H24.1429C24.6571 5.38462 25 5.72308 25 6.23077ZM9.57143 5.38462H16.4286V3.69231H9.57143V5.38462ZM16.4286 12.1538C16.4286 11.6462 16.0857 11.3077 15.5714 11.3077H10.4286C9.91429 11.3077 9.57143 11.6462 9.57143 12.1538C9.57143 12.6615 9.91429 13 10.4286 13H15.5714C16.0857 13 16.4286 12.6615 16.4286 12.1538ZM20.7143 17.2308H19V24H22.4286C23.8857 24 25 22.9 25 21.4615V15.4538C23.8857 16.5538 22.3429 17.2308 20.7143 17.2308Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconBusinessSettings, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Icon_Business_Settings.de7a57af.svg";
export { ForwardRef as ReactComponent };